﻿import { Slider } from 'antd';
import React from 'react';
import EnumSelect from 'msg-ui-react/dist/components/data-entry/EnumSelect';
import { ComponentConfigsMap } from '../forms/ComponentsMap';
import { ChartBackground, ChartDetail, ChartHybrid, ChartType, IChartState, IChartStateOptions, isEmptyChart, isStandAloneChart } from '../models/ChartModels';

import { style } from './styles';


export const chartConfig: ComponentConfigsMap<Omit<IChartState, 'bathymetry'>, IChartStateOptions> = {    
    type: {
        hidden: (state, options) => {
            if (options?.visibility?.type !== undefined)
                return !options.visibility.type;
            else
                return false;
        },
        component: (state, options) => <EnumSelect
            enumType={ChartType}
            style={style}
            enumOptions={{
                valueType: 'number',
                visible: options?.visibility?.typeKeys?.show,
                hidden: options?.visibility?.typeKeys?.hide,
                labels: {
                    [ChartType.OpenStreetMap]: 'OpenStreetMap'
                },
                order: [
                    ChartType.None,
                    ChartType.Paper,
                    ChartType.ECDIS,                    
                    ChartType.OpenStreetMap,
                    ChartType.Satellite
                ]
            }}
        />       
    },
    detail: {
        hidden: (state, options) => {
            if (options?.visibility?.detail !== undefined)
                return !options?.visibility.detail;
            else
                return isEmptyChart(state) || isStandAloneChart(state);
        },
        component: (state, options) => <EnumSelect
            enumType={ChartDetail}
            enumOptions={{
                valueType: 'number',
                visible: options?.visibility?.detailKeys?.show,
                hidden: options?.visibility?.detailKeys?.hide,
            }}
            style={style}
        />
    },
    hybrid: {
        hidden: (state, options) => {
            if (options?.visibility?.hybrid !== undefined)
                return !options.visibility.hybrid;
            else
                return isEmptyChart(state) || isStandAloneChart(state);
        },
        component: (state, options) => <EnumSelect
            enumType={ChartHybrid}
            enumOptions={{
                valueType: 'number',
                visible: options?.visibility?.hybridKeys?.show,
                hidden: options?.visibility?.hybridKeys?.hide
            }}
            style={style}
        />
    },
    background: {
        hidden: (state, options) => {
            if (options?.visibility?.background !== undefined)
                return !options.visibility.background;
            else
                return isEmptyChart(state) || isStandAloneChart(state) || state.hybrid !== ChartHybrid.Land
        },
        component: (state, options) => <EnumSelect
            enumType={ChartBackground}
            style={style}
            enumOptions={{
                valueType: 'number',
                visible: options?.visibility?.backgroundKeys?.show,
                hidden: options?.visibility?.backgroundKeys?.hide,
                labels: {
                    [ChartBackground.OpenStreetMap]: 'OpenStreetMap',
                }
            }}
        />
    },
    brightness: {
        hidden: (state, options) => options?.visibility?.brightness === false,
        component: <Slider
            min={-0.8} max={0.8} step={0.05} marks={{ 0: '0%' }}
            tooltip={{ formatter: value => `${Math.round((value ?? 0) * 100).toFixed()}%` }}
            style={{ marginBottom: 16 }}
        />
    },
    // note: moved to Mapsidebar for now because bathymetry will be rendered in a separate form
    //bathymetry: {
    //    hidden: (state, options) => {            
    //        if (options?.visibility?.bathymetry !== undefined)
    //            return !options.visibility.bathymetry;
    //        else {
    //            //console.log(!state.bathymetry, !state.visible, isStandAloneLayer(state), state.hybrid !== ChartHybrid.Bathymetry )
    //            return !state.bathymetry || !state.visible || isStandAloneLayer(state) || state.hybrid !== ChartHybrid.Bathymetry;
    //        }
    //    },
    //    component: bathymetryConfig
    //}
};